import {isCustomProperty} from 'cl-api';
import * as _ from 'lodash';
import {createSelector} from 'reselect';
import {StoreState} from '../../App/initialStore';
import {getFormValues} from 'redux-form';
import {PRODUCT_FORM_NAME} from './ProductPage';
import {
  createVariationKey,
  getUnusedVariations,
} from '../../shared/ActionsManager/VariationsActions/VariationsActionsHelpers';
import {VARIATION_OPTIONS_FIELDS, PRODUCT_VARIATIONS, PRODUCT_LISTINGS_TABLE, PRODUCT_LISTINGS_COUNT} from './consts';
import {variationType} from '../../shared/components/Dialogs/AddVariationDialog/AddVariationDialog';
import {Map} from 'immutable';
import {aspectValuesType} from '../../shared/components/Dialogs/EditVariationOptionsDialog/EditVariationOptionsDialog';
export type VariationsType = {[name: string]: variationType};

export const getProductFormValues = (state: StoreState) => getFormValues(PRODUCT_FORM_NAME)(state);

export const getProductListingsTableState = (state: StoreState) => _.get(state.table, PRODUCT_LISTINGS_TABLE);

export const getVariationsInternal = createSelector(
  [getProductFormValues],
  productFormValues => {
    return _.get(productFormValues, PRODUCT_VARIATIONS);
  }
);

export const getProductListings = createSelector(
  [getProductListingsTableState],
  productListingsTableState => {
    return _.get(productListingsTableState, 'data');
  }
);

export const getProductListingsCountFormValues = createSelector(
  [getProductFormValues],
  productFormValues => {
    return _.get(productFormValues, PRODUCT_LISTINGS_COUNT);
  }
);

export const getVariations = createSelector(
  [getVariationsInternal],
  variations => {
    const convertedVariations: VariationsType = {};
    _.forEach(variations, (variation: object) => {
      const variationsSpecific = _.pickBy(
        variation,
        (value, key) => VARIATION_OPTIONS_FIELDS.indexOf(key) !== -1 || isCustomProperty(key)
      );
      convertedVariations[createVariationKey(variationsSpecific)] = {
        ...variation,
        VariationSpecifics: variationsSpecific as aspectValuesType,
      };
    });
    return convertedVariations;
  }
);

export const getVariationSpecificsSet = createSelector(
  [getVariations],
  variations => {
    return getVariationSpecificsSetByVariations(variations);
  }
);

export const getVariationSpecificsSetByVariations = variations => {
  const variationSpecificsSet = {};
  _.forEach(variations, variationValue => {
    _.forEach(variationValue.VariationSpecifics, (specificValue, specificName) => {
      variationSpecificsSet[specificName] = _.uniq([...(variationSpecificsSet[specificName] || []), specificValue]);
    });
  });
  return variationSpecificsSet;
};

export const getVariationAspectNames = createSelector(
  [getVariationSpecificsSet],
  variationSpecificsSet => {
    return _.keys(variationSpecificsSet);
  }
);

export const getVariationsTableRows = createSelector(
  [getVariationsInternal],
  variations => {
    const totalVariationsData = [];
    _.forEach(variations, (variation: object, index) => {
      totalVariationsData.push([
        index,
        {...variation, thumbnail: variation['Images'] ? variation['Images'] : undefined, _id: index},
      ]);
    });
    return Map(totalVariationsData);
  }
);

export const getUnusedProductVariations = createSelector(
  [getVariations, getVariationSpecificsSet],
  (currentVariations, variationsSpecificSet) => {
    return getUnusedVariations(currentVariations, variationsSpecificSet);
  }
);
